module.exports = __webpack_public_path__ + "static/patient1_mobile-f3b0f5108c194b93b0e19de30bebdd59.jpg";